import http from '@/http';

export default {

    approvers: {
        save(id, approvers) {
            return http.put(`/systems/${id}/approvers`, approvers);
        },
    },

    list() {
        return http.get('/systems');
    },
    fetch(id) {
        return http.get(`/systems/${id}`);
    },
    remove(id) {
        return http.delete(`/systems/${id}`);
    },
    save(form) {
        return http.post('/systems', form);
    },
    update(id, form) {
        return http.put(`/systems/${id}`, form);
    },

};



// WEBPACK FOOTER //
// ./src/api/systems.js